import { ToastId, useToast } from "@chakra-ui/react";
import { useCallback, useState } from "react";

import { MessageToastProperties, useMessageToast } from "./useMessageToast";

export const useToastLoader = () => {
  const [toastId, setToastId] = useState<ToastId | undefined>();
  const toastManager = useToast();
  const toast = useMessageToast();

  // use this when you have separate closures where toast and dismissToast are called
  const dismissToast = useCallback(
    (id?: ToastId) => {
      if (id || toastId) {
        toastManager.close(id ?? (toastId as ToastId));
      } else {
        toastManager.closeAll();
      }
      setToastId(undefined);
    },
    [toastId, toastManager],
  );

  return {
    dismissToast,
    toast: useCallback(
      ({ position = "bottom", isClosable = false, ...options }: MessageToastProperties) => {
        const toastId = toast({
          position,
          ...options,
          isClosable: isClosable,
          shouldDismiss: isClosable,
        });
        setToastId(toastId);

        return {
          // use this when toast and dismissToast are called in the same closure
          dismissToast: () => {
            if (toastId) {
              toastManager.close(toastId);
            }
            setToastId(undefined);
          },
          toastId,
        };
      },
      [toast, toastManager],
    ),
    toastId,
  };
};
